import { render } from "./UserTopNav.vue?vue&type=template&id=8456221a"
import script from "./UserTopNav.vue?vue&type=script&lang=js"
export * from "./UserTopNav.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__